import './SettingsPreferrences.scss'
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { List, ListItem, ListItemText, ListSubheader } from "@mui/material";
import SettingsSyncToCal from '../SettingsSyncToCal/SettingsSyncToCal';

export default function SettingsPreferrences() {
    const { t } = useTranslation();
    const [selectedIndex, setSelectedIndex] = useState(1);

    const handleListItemClick = (event, index) => {
        setSelectedIndex(index);
    };

    return (
        <div className='settings-preferrences__cntr'>
            <div className='settings-preferrences__left-content'>
                <div className='settings-preferrences__left-content-title'>{t('settingsScreen.yourPreferrences')}</div>
                {/* <List component="nav" aria-label=""
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                <i className="icon-Calendar" />{t('settingsScreen.General')}
                            </ListSubheader>
                        }>
                        <ListItem button selected={selectedIndex === 0} onClick={(event) => handleListItemClick(event, 0)} >
                            <ListItemText primary={t('settingsScreen.timeZones')} />
                        </ListItem>
                    </List>
                    <Divider /> */}
                <List component="nav" aria-label=""
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            <i className="icon-Calendar" />{t('settingsScreen.myBlockMonth')}
                        </ListSubheader>
                    }>
                    <ListItem button selected={selectedIndex === 1} onClick={(event) => handleListItemClick(event, 1)} >
                        <ListItemText primary={t('settingsScreen.syncToCalendar')} />
                    </ListItem>
                    {/* <ListItem button selected={selectedIndex === 2} onClick={(event) => handleListItemClick(event, 2)} >
                            <ListItemText primary={t('settingsScreen.timeZones')} />
                        </ListItem> */}
                </List>
                {/* <Divider />
                    <List component="nav" aria-label=""
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                <i className="icon-Calendar" />{t('settingsScreen.allBlocks')}
                            </ListSubheader>
                        }>
                        <ListItem button selected={selectedIndex === 3} onClick={(event) => handleListItemClick(event, 3)} >
                            <ListItemText primary={t('settingsScreen.privacySettings')} />
                        </ListItem>
                    </List>
                    <Divider />
                    <List component="nav" aria-label=""
                        subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                <i className="icon-Calendar" />{t('settingsScreen.friendsBlock')}
                            </ListSubheader>
                        }>
                        <ListItem button selected={selectedIndex === 4} onClick={(event) => handleListItemClick(event, 4)} >
                            <ListItemText primary={t('settingsScreen.privacySettings')} />
                        </ListItem>
                    </List> */}
            </div>


            <div className='settings-preferrences__right-content'>
                {selectedIndex === 1 ? <SettingsSyncToCal /> : ''}
            </div>
        </div>
    )
}